import PropTypes from 'prop-types';

// Inline nav + chrome icons cloned from the design-system web_portal kit.
// Most are authored for the shared 20x20 viewBox; an entry may override
// `viewBox`/`strokeWidth` when the source art uses a different canvas (the
// gear is a 24x24 Feather cog, so it carries its own).
const NAV_ICONS = {
  dashboard: { d: 'M3 3.2h7v6.2H3V3.2Zm0 8.4h7V17H3v-5.4Zm9 0h7V17h-7v-5.4Zm0-8.4h7v6.2h-7V3.2Z' },
  campaigns: { d: 'M4 4h12v3.5H4V4Zm0 5.2h12v3.5H4V9.2Zm0 5.3h8V18H4v-3.5Z' },
  stores: { d: 'M4 8.5 5.2 4h9.6L16 8.5M4 8.5h12M4 8.5V16h12V8.5M8 16v-4h4v4' },
  terms: { d: 'M6 3h5l3 3v11H6V3Zm5 0v3h3M8 10h6M8 13h6' },
  settings: {
    viewBox: '0 0 24 24',
    strokeWidth: 1.9,
    d: 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z',
  },
};

function Svg({ children, className, viewBox = '0 0 20 20', strokeWidth = 1.6 }) {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}
Svg.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  viewBox: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export function NavIcon({ name, className }) {
  const icon = NAV_ICONS[name];
  if (!icon) return null;
  return (
    <Svg className={className} viewBox={icon.viewBox} strokeWidth={icon.strokeWidth}>
      <path d={icon.d} />
    </Svg>
  );
}
NavIcon.propTypes = { name: PropTypes.string, className: PropTypes.string };

// Chevron points inward when open (collapse) and outward when collapsed (expand).
export function ChevronIcon({ collapsed }) {
  return (
    <Svg>
      <path d={collapsed ? 'M8 5l5 5-5 5' : 'M12 5l-5 5 5 5'} />
    </Svg>
  );
}
ChevronIcon.propTypes = { collapsed: PropTypes.bool };

export function LogoutIcon() {
  return (
    <Svg>
      <path d="M8 3H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3M13 13l3-3-3-3M16 10H8" />
    </Svg>
  );
}
